import * as React from 'react'
import { useIntl } from 'react-intl'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { TableHead } from '@mui/material'
import ConfirmDelete from '../../../../components/dialogs/ConfirmDelete'
import ResetTemporaryPassword from '../../../../components/dialogs/ResetTemporaryPassword'
import { ManagerState } from '../../../../features/types'
import AddManagerDialog from './AddManagerDialog'

interface Props {
    managersData: ManagerState[]
    isFetching: boolean
    onResetPassword: (id: number) => void
    onDelete: (subject: number) => void
}

const ManagersTable: React.FC<Props> = ({
    managersData = [],
    isFetching,
    onDelete,
    onResetPassword,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Box>
            <TableContainer
                component={Paper}
                sx={{ border: 1, borderColor: 'grey.100', borderRadius: 2 }}
                elevation={0}
            >
                <Table
                    sx={{ minWidth: 500 }}
                    aria-label="custom pagination table"
                >
                    <TableHead sx={{ bgcolor: 'grey.100' }}>
                        <TableRow>
                            <TableCell>
                                {formatMessage({ id: 'fullName' })}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'phone' })}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'temporaryPassword' })}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'email' })}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'role' })}
                            </TableCell>

                            <TableCell align="right">
                                {formatMessage({ id: 'edit' })}
                            </TableCell>

                            <TableCell align="right">
                                {formatMessage({ id: 'delete' })}
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    {managersData.length ? (
                        <TableBody>
                            {managersData.map((row) => (
                                <TableRow key={row.id}>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        {row.lastName} {row.firstName}
                                    </TableCell>

                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        {row.mobile}
                                    </TableCell>

                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        <ResetTemporaryPassword
                                            password={row.password}
                                            fullName={
                                                row.lastName +
                                                ' ' +
                                                row.firstName
                                            }
                                            isLoading={isFetching}
                                            confirmAction={() =>
                                                onResetPassword(
                                                    row.id as number,
                                                )
                                            }
                                        />
                                    </TableCell>

                                    <TableCell>{row.email}</TableCell>

                                    <TableCell>
                                        {formatMessage({
                                            id: row.role.toLowerCase(),
                                        })}
                                    </TableCell>

                                    <TableCell
                                        style={{ width: 60 }}
                                        align="right"
                                    >
                                        <AddManagerDialog
                                            editMode={true}
                                            editManager={row}
                                        />
                                    </TableCell>

                                    <TableCell
                                        style={{ width: 60 }}
                                        align="right"
                                    >
                                        <ConfirmDelete
                                            confirmAction={() =>
                                                onDelete(row.id as number)
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}

                        </TableBody>
                    ) : (
                        !isFetching && (
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                        align="center"
                                        colSpan={7}
                                    >
                                        {formatMessage({ id: 'noData' })}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )
                    )}

                </Table>
            </TableContainer>
        </Box>
    )
}

export default ManagersTable
